export default "__VITE_ASSET__pFp3Vu7h__"